document.addEventListener('DOMContentLoaded', () => {
  initializeTextBlockCarousel();
});

function initializeTextBlockCarousel() {
  const carousels = document.querySelectorAll(".js-text-block-carousel");

  if (!carousels.length) return;

  if (window.innerWidth >= 992) {
    carousels.forEach((element, index) => {
      const uniqueClass = `js-text-block-carousel-${String(index + 1).padStart(2, "0")}`;
      element.classList.add(uniqueClass);

      const splide = new Splide(element, {
        type     : 'slide',
        perPage  : 2,
        perMove  : 1,
        gap      : '20px',
        pagination: false,
        arrows: false,
        breakpoints: {
          1199: {
            perPage: 2,
          },
          991: {
            perPage: 1,
          },
        }
      });

      splide.mount();
      element.splideInstance = splide;
    });
  }
}

function initCursorDragEffect() {
  const cursorDrag = document.querySelector('.js-cursor-drag');
  if (!cursorDrag) return;

  const body = document.body;
  let targetX = 0, targetY = 0, currentX = 0, currentY = 0;
  const speed = 0.1;

  const updateBounds = () => ({
    maxX: body.clientWidth - 80,
    maxY: body.clientHeight - cursorDrag.offsetHeight
  });

  document.addEventListener('mousemove', (e) => {
    const bounds = updateBounds();
    targetX = Math.min(bounds.maxX, Math.max(0, e.pageX));
    targetY = Math.min(bounds.maxY, Math.max(0, e.pageY));
  });

  function animate() {
    currentX += (targetX - currentX) * speed;
    currentY += (targetY - currentY) * speed;

    cursorDrag.style.left = `${currentX}px`;
    cursorDrag.style.top = `${currentY}px`;

    requestAnimationFrame(animate);
  }

  animate();

  document.querySelectorAll('.js-text-block-carousel').forEach(target => {
    target.addEventListener('mouseenter', () => cursorDrag.classList.add('active'));
    target.addEventListener('mouseleave', () => cursorDrag.classList.remove('active'));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCursorDragEffect();
});